// lookup codes
export const STATUS_AWAITING_SUBMIT = 'STATUS_AWAITING_SUBMIT'
export const STATUS_AWAITING_APPROVAL = 'STATUS_AWAITING_APPROVAL'
export const STATUS_APPROVED = 'STATUS_APPROVED'
export const STATUS_SURRENDERED = "STATUS_SURRENDERED"
export const STATUS_AWAITING_SURRENDER = "STATUS_AWAITING_SURRENDER"
export const STATUS_REJECTED = "STATUS_REJECTED"

export const EMPLOYEE_TYPE_UNDERTAKING = "EMPLOYEE_TYPE_UNDERTAKING"
export const EMPLOYEE_TYPE_OTHER = "EMPLOYEE_TYPE_OTHER"

export const ANNUAL_RETURN_STATUS_AWAITING_SUBMIT = "ANNUAL_RETURN_STATUS_AWAITING_SUBMIT"
export const ANNUAL_RETURN_STATUS_AWAITING_APPROVAL = "ANNUAL_RETURN_STATUS_AWAITING_APPROVAL"
export const ANNUAL_RETURN_STATUS_APPROVED = "ANNUAL_RETURN_STATUS_APPROVED"

export const ANNUAL_RETURN_TYPE_ANNUAL = "ANNUAL_RETURN_TYPE_ANNUAL"
export const ANNUAL_RETURN_TYPE_FINAL = "ANNUAL_RETURN_TYPE_FINAL"

export const SYS_PARAM_HTML = "SYS_PARAM_HTML"
export const SYS_PARAM_TEXT = "SYS_PARAM_TEXT"
export const SYS_PARAM_NUMBER = "SYS_PARAM_NUMBER"

// lookup code types
export const EMPLOYEE_RESTRICTIONS = "EMPLOYEE_RESTRICTIONS"
export const LOBBYIST_STATUS = "LOBBYIST_STATUS"
export const ANNUAL_RETURN_TYPE = "ANNUAL_RETURN_TYPE"

// roles
export const ROLE_ADMIN = "Admin"
export const ROLE_LOBBYIST = "Lobbyist"

// system parameters
export const FAQ_URL = "FAQ_URL"
export const COMPLAINTS_URL = "COMPLAINTS_URL"
export const HOME_PAGE_TEXT = "HOME_PAGE_TEXT"
export const REGISTRATION_TEXT = "REGISTRATION_TEXT"
export const ANNUAL_RETURN_START = "ANNUAL_RETURN_START"
export const ANNUAL_RETURN_PAGE_TEXT = "ANNUAL_RETURN_PAGE_TEXT"
export const DPC_NOTIFICATION_EMAIL = "DPC_NOTIFICATION_EMAIL"


// WEBPACK FOOTER //
// ./src/js/const.js